(function(angular){
	'use strict';
	
	var redemptionDiscountTableObject = {
		templateUrl: ['STATIC_BASE_PATH', templateUrlFunction],
		bindings: {
			'type' : '<',
			'loadingTables': '<',
			'data': '<'
		},
		controller: [
			RedemptionDiscountTableFunction
		],
		controllerAs: 'redemptionDiscountTable'
	};
	
	angular
		.module('redemptionRequestModule')
		.component('redemptionDiscountTable', redemptionDiscountTableObject);
	
	function templateUrlFunction(STATIC_BASE_PATH){
		return STATIC_BASE_PATH + '/static/html/redemptions/redemption-discount-table.html';
	}
	
	function RedemptionDiscountTableFunction(){
		var redemptionTable = this;

		redemptionTable.$onChanges = function(){
			if(angular.isDefined(redemptionTable.data)) {
				redemptionTable.introTable = redemptionTable.data.introTable;
				redemptionTable.postIntroTable = redemptionTable.data.postIntroTable;
				if(redemptionTable.type === 'ipo') {
					redemptionTable.ipoValue = Number(Big(redemptionTable.postIntroTable.grossValueOfShares).plus(redemptionTable.introTable.netRedemptionValue));
					redemptionTable.displayIpoTable = redemptionTable.ipoValue !== 0;
				} else {
					redemptionTable.displayIntroTable = redemptionTable.introTable.netRedemptionValue !== 0;
					redemptionTable.displayPostIntroTable = redemptionTable.postIntroTable.grossValueOfShares !== 0;
				}
			} else {
				redemptionTable.displayIntroTable = false;
				redemptionTable.displayPostIntroTable = false;
				redemptionTable.displayIpoTable = false;
			}
		};
	}
})(window.angular);